"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

const DynamicShopFullwidth = dynamic(
     () => import("@/components/shop/ShopFullwidth"),
     { ssr: false }
);

export default function Craciun() {
     const [productsData, setProductsData] = useState([]);
     const [loading, setLoading] = useState(true);

     useEffect(() => {
          async function fetchProducts() {
               setLoading(true);
               try {
                    const response = await fetch(`/api/products/craciun`);
                    const data = await response.json();

                    if (data.products) {
                         setProductsData(data.products);
                    }
               } catch (error) {
                    console.error("Error loading products:", error);
               } finally {
                    setLoading(false);
               }
          }

          fetchProducts();
     }, []);

     if (loading) {
          return (
               <div style={{
                    minHeight: "400px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
               }}>
                    <p>Se încarcă produsele...</p>
               </div>
          );
     }

     return (
          <>
               <div className='tf-page-title'>
                    <div className='container-full'>
                         <div className='heading text-center'>
                              🎄 Colecția de Crăciun
                         </div>
                         <p className='text-center text-2 text_black-2 mt_5'>
                              Brazi artificiali, ornamente și decorațiuni pentru sărbători
                         </p>
                    </div>
               </div>
               <DynamicShopFullwidth productsData={productsData} />
          </>
     );
}
